import dayjs from "dayjs";

/**
 * Returns the maximum date of birth possible,
 * given that the user needs to be an adult (i.e.: 18 years).
 * @function
 * @name getMaxDateOfBirth
 * @kind function
 * @returns {dayjs.Dayjs} Neutral timezone date.
 * @exports
 */
export function getMaxDateOfBirth(): dayjs.Dayjs {
  const adulthoodAge = 18;
  const today = new Date();
  const maxDate = new Date(
    today.setFullYear(today.getFullYear() - adulthoodAge)
  );
  return dayjs(maxDate);
}
